// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
// PhoneCallQueueConfigService is the service that provides methods to manage call queue settings.
// NWX Endpoint, location-id is not used.
export const PhoneCallQueueConfigService = {
    Create(fn, req) {
        return fn(`/phone/callqueue-config/v1`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // Read returns the call queue settings for a given call queue. Includes assigned devices.
    Read(fn, req) {
        try {
            fm.validateUrlParam(req["callQueueId"], "callQueueId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/callqueue-config/v1/${req["callQueueId"]}?${fm.renderURLSearchParams(req, ["callQueueId"])}`, { method: "GET" });
    },
    // List returns a list of call queues for a tenant. Excludes assigned devices.
    List(fn, req) {
        return fn(`/phone/callqueue-config/v1?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // Update updates the call queue settings for a given call queue. Does not update assigned devices.
    Update(fn, req) {
        try {
            fm.validateUrlParam(req["callQueueId"], "callQueueId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/callqueue-config/v1/${req["callQueueId"]}`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    // Delete deletes a call queue. Checks for usage before deleting and rejects if a usage is found.
    Delete(fn, req) {
        try {
            fm.validateUrlParam(req["callQueueId"], "callQueueId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/callqueue-config/v1/${req["callQueueId"]}?${fm.renderURLSearchParams(req, ["callQueueId"])}`, { method: "DELETE" });
    },
    // UpdateDevices updates the devices assigned to a call queue.
    UpdateDevices(fn, req) {
        try {
            fm.validateUrlParam(req["callQueueId"], "callQueueId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/callqueue-config/v1/${req["callQueueId"]}/devices`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    // Usage returns the usages of a call queue.
    Usage(fn, req) {
        try {
            fm.validateUrlParam(req["callQueueId"], "callQueueId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/callqueue-config/v1/${req["callQueueId"]}/usage?${fm.renderURLSearchParams(req, ["callQueueId"])}`, { method: "GET" });
    },
};
